import { AfterViewInit, ChangeDetectorRef, Component, Input, OnInit, Renderer2 } from '@angular/core';
import { DateAdapter } from '@angular/material/core';
import { MatCalendarCellCssClasses } from '@angular/material/datepicker';
import { LangChangeEvent, TranslateService } from '@ngx-translate/core';
import { TicketReservationPlugin } from 'projects/qcloud-models/reservation-plugin/ticket-reservation-plugin';
import { ReservationMonthCapacity } from 'projects/qcloud-models/reservation/reservation-month-capacity';
import { TicketReservationService } from '../../../services/ticket-reservation.service';

@Component({
  selector: 'app-reservation-calendar',
  templateUrl: './reservation-calendar.component.html',
  styleUrls: ['./reservation-calendar.component.scss']
})
export class ReservationCalendarComponent implements OnInit, AfterViewInit {

  @Input() reservationsEndTime: number;
  @Input() categoryMonthCapacity: ReservationMonthCapacity[];
  selectedMonthCapacity: ReservationMonthCapacity;
  selectedDate: Date;
  minDate = new Date();
  maxDate: Date;
  selectedMonth: number;
  ticketReservation = new TicketReservationPlugin();
  myDateFilter;

  constructor(private ticketReservationService: TicketReservationService, private _adapter: DateAdapter<any>,
    private translate: TranslateService, private cdr: ChangeDetectorRef, private renderer: Renderer2) {
    this._adapter.setLocale(this.translate.currentLang);
    translate.onLangChange.subscribe((event: LangChangeEvent) => {
      this._adapter.setLocale(event.lang);
      this.cdr.detectChanges();
    });
    ticketReservationService.ticketReservation.subscribe((val: TicketReservationPlugin) => {
      this.ticketReservation = val;
      this.getMonthCapacityForCategory();
    });
  }

  ngOnInit(): void {
    this.selectedMonth = new Date().getMonth();
    this.maxDate = new Date(this.minDate.valueOf());
    this.maxDate.setDate(this.maxDate.getDate() + this.reservationsEndTime);
    this.getMonthCapacityForCategory();
  }

  ngAfterViewInit() {
    let nextMonthButton = document.querySelector('mat-calendar .mat-calendar-next-button');
    let previousMonthButton = document.querySelector('mat-calendar .mat-calendar-previous-button');

    if (nextMonthButton && previousMonthButton) {
      this.renderer.listen(nextMonthButton, "click", () => {
        this.selectedMonth = (this.selectedMonth + 1) % 12;
        this.getMonthCapacityForCategory();
      });
      this.renderer.listen(previousMonthButton, "click", () => {
        this.selectedMonth--;
        if (this.selectedMonth < 0) {
          this.selectedMonth += 12;
        }

        this.getMonthCapacityForCategory();
      });
    }
  }

  handleMonthSelected(event: Date) {
    this.selectedMonth = event.getMonth();
    this.getMonthCapacityForCategory();
  }

  getMonthCapacityForCategory() {
    this.selectedMonthCapacity = this.categoryMonthCapacity.find(
      x => x.categoryId == this.ticketReservation.categoryId && new Date(x.date).getMonth() == this.selectedMonth);
    this.myDateFilter = (d: Date): boolean => {
      if (!this.selectedMonthCapacity) {
        return false;
      }
      return this.selectedMonthCapacity.capacity[d.getDate() - 1] >= 0;
    }
  }

  onSelect(event) {
    this.selectedDate = event;
    this.ticketReservation.reservationTime = event;
    this.ticketReservationService.updateTicketReservation(this.ticketReservation);
  }

  dateClass() {
    return (date: Date): MatCalendarCellCssClasses => {
      if (this.ticketReservation.categoryId) {
        if (date.valueOf() > this.minDate.valueOf() && date.valueOf() < this.maxDate.valueOf()) {
          if (this.selectedMonthCapacity.capacity[date.getDate() - 1] > 0 ) {
            return 'selectable-date'
          }
          else if (this.selectedMonthCapacity.capacity[date.getDate() - 1] <= 0) {
              return 'inactive-date'
          }
        } else if (date.valueOf() > this.maxDate.valueOf()) {
          return 'future-date'
        }
      }
      return;
    };
  }

}
